import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_NOTIFICATION_BELL_STATE_COLLECTION_NAME =
  "notification-bell-state";

export const useRxCollectionNotificationBellState =
  (): RxCollection<NotificationBellState> | null =>
    useRxCollection<NotificationBellState>(
      RXDB_NOTIFICATION_BELL_STATE_COLLECTION_NAME,
    );

const NOTIFICATION_BELL_STATE_SCHEMA_LITERAL = {
  title: "notification bell state schema",
  version: 2,
  description:
    "Per-user watermark for when the bell was last opened / all marked read",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      // `bellstate-${userId}` — "bellstate-" prefix (10) + userId (100) = 110.
      type: "string",
      maxLength: 120,
    },
    userId: {
      type: "string",
      maxLength: 100,
    },
    lastBellOpenedAt: {
      type: ["string", "null"],
      format: "date-time",
    },
    lastMarkAllReadAt: {
      type: ["string", "null"],
      format: "date-time",
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "userId", "meta"],
  indexes: ["userId"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(NOTIFICATION_BELL_STATE_SCHEMA_LITERAL);

export type NotificationBellState = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const NOTIFICATION_BELL_STATE_SCHEMA: RxJsonSchema<NotificationBellState> =
  NOTIFICATION_BELL_STATE_SCHEMA_LITERAL;
